import ReactDOM from 'react-dom';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import ResultRow from './result_row';
import './result_row.scss';

interface AnalyzeResultProp {
  fileId: string;
  resourceName: string;
  pageIds: Array<string>;
  pngSrcs: Array<string>;
}

const AnalyzeResult: React.FC<AnalyzeResultProp> = (
  props: AnalyzeResultProp,
) => {
  // @ts-ignore
  const [timerId, setTimerId] = useState<NodeJS.Timeout | number>(0);
  const refTimerId = useRef(timerId);
  const [visibleFlg, setVisibleFlg] = useState(false);

  // 解析が終わったらダウンロードボタンを表示
  const visibleDownloadButton = useCallback(() => {
    const prog = document.getElementsByClassName('analyze_progress');
    const vFlg = !Array.from(prog).some(
      (pro) => pro.textContent === 'ただいま補正中...',
    );

    if (vFlg) {
      setVisibleFlg(vFlg);
      clearInterval(refTimerId.current as number);
    }
  }, []);

  useEffect(() => {
    refTimerId.current = timerId;
  }, [timerId]);
  useEffect(() => {
    setTimerId(setInterval(visibleDownloadButton, 3000));
  }, [visibleDownloadButton]);

  return (
    <div>
      <div>
        {props.pngSrcs.map((value) => (
          // @ts-ignore
          <ResultRow key={value['page_id']} pngSrcs={value} />
        ))}
      </div>
      <div className="my-10">
        {visibleFlg ? (
          <>
            <a
              href={`/debug/${props.resourceName}/${
                props.fileId
              }/download.zip?page_ids=${encodeURIComponent(
                props.pageIds.join(','),
              )}`}
              className="inline-block m-2 px-6 py-3 text-white bg-blue-800 rounded cursor-pointer"
            >
              ダウンロードする（.zip）
            </a>
          </>
        ) : null}
      </div>
    </div>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  // 表示
  const result = document.getElementById('result');
  if (result !== null) {
    // @ts-ignore
    const ids = JSON.parse(result.getAttribute('data-ids'));
    const resource = result.getAttribute('data-resource');
    const fileid = result.getAttribute('data-fileid');
    // @ts-ignore
    const pngsrcs = JSON.parse(result.getAttribute('data-pngsrcs'));
    ReactDOM.render(
      <AnalyzeResult
        // @ts-ignore
        fileId={fileid}
        // @ts-ignore
        resourceName={resource}
        pageIds={ids}
        pngSrcs={pngsrcs}
      />,
      result,
    );
  }
});
